
import { defineComponent, Ref, ref, onMounted, computed } from "vue";
import useAlert from "../../../composables/Alert";
import Button from "@/components/Button.vue";
import axios from "axios";
import { Modal } from "bootstrap";

export default defineComponent({
  name: "ModalUploadFiltro",
  components: {
    Button
  },
  props: {
    fechaModal: Function,
    pegarListaDePlanilhas: Function,
    marcasFiltro: { type: Array as () => Array<{ nome: string; id_marca_produto: string | number }>, default: () => [] },
  },
  emits: ['uploaded'],

  setup(props, { emit }) {
    const { showTimeAlert } = useAlert();
    const buttonText = ref('Enviar planilha');
    const botaoDesabilitado = ref(false);
    const arquivo: Ref<any> = ref();
    const marca: Ref<string | null> = ref(null);
    const fileInput: Ref<any> = ref(null);
    const file: Ref<any> = ref(null);
    const loadingUpload: Ref<boolean> = ref(false);
    const tipoVeiculo: Ref<string> = ref('');
    const tipos: Ref<any> = ref([
      'Leve',
      'Pesado'
    ]);
    const modalConfirmaAcao: Ref<any> = ref()

    const marcas = computed(() => props.marcasFiltro);

    function handleFileChange(event: any) {
      arquivo.value = event.target.files[0]
    }

    async function getToken() {
      return localStorage.getItem('token_usuario');
    }

    function dropHandler(e) {
      stopDefault(e)

      if (e.dataTransfer.items) {
        [...e.dataTransfer.items].forEach((item) => {
          if (item.kind === "file") {
            file.value = item.getAsFile();
          }
        });
      } else {
        [...e.dataTransfer.files].forEach((fileParam) => {
          file.value = fileParam;
        });
      }
      arquivo.value = file.value
    }

    function stopDefault(e) {
      e.stopPropagation();
      e.preventDefault();
    }

    function limparArquivo() {
      arquivo.value = null
    }

    async function uploadPlanilhaFiltros(){
      if(!arquivo.value) return
      loadingUpload.value = true
      botaoDesabilitado.value = true
      try{
        arquivo.value.idMarca = marca.value;
        const timeStamp = (new Date()).getTime();

        const formData = new FormData()
        formData.append('arquivo', arquivo.value);
        formData.append('idMarca', arquivo.value.idMarca);
        formData.append('nome', `${timeStamp}-${arquivo.value.name}`);
        formData.append('pasta', 'planilhas/filtros');
        formData.append('tipoVeiculo', tipoVeiculo.value);

        const response =  await axios.post("uploadPlanilhaFiltroAzure", formData, {
          headers: {
            'Allow-Access-Control-Origin': '*',
            'Content-Type': 'application/json;charset=utf-8',
            'Authorization': `Bearer ${await getToken()}`
          }
        });
        const { data , message, error } = response.data

        if(error){
          showTimeAlert('Error ao enviar planilha', 'error')
          console.log('Error ao enviar planilha', message)
          loadingUpload.value = false
          botaoDesabilitado.value = false
          return
        }
        showTimeAlert('Planilha enviada com sucesso', 'success')
        props.pegarListaDePlanilhas && props.pegarListaDePlanilhas()
      }catch(error){
        showTimeAlert('Error ao enviar planilha', 'error')
        loadingUpload.value = false
        botaoDesabilitado.value = false
      }finally{
        loadingUpload.value = false
        botaoDesabilitado.value = false
        fechaModalConfirmaAcao()
        closeModal()
      }
    }

    function abreModalConfirmaAcao() {
      modalConfirmaAcao.value.show()
    }

    function fechaModalConfirmaAcao() {
      modalConfirmaAcao.value.hide()
    }

    function closeModal() {
      arquivo.value = "";
      marca.value = "";
      tipoVeiculo.value = "";
      props.fechaModal && props.fechaModal()
    }

    const openInput = () => fileInput.value.click();

    onMounted(async () => {
      modalConfirmaAcao.value = new Modal(document.querySelector(`#modalConfirmaAcao`));
    })

    return {
      dropHandler,
      stopDefault,
      arquivo,
      limparArquivo,
      buttonText,
      botaoDesabilitado,
      marcas,
      marca,
      openInput,
      handleFileChange,
      fileInput,
      loadingUpload,
      uploadPlanilhaFiltros,
      tipos,
      tipoVeiculo,
      abreModalConfirmaAcao,
      closeModal
    }
  },
});
